import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { IBasketService } from '../../../../services/basket/basket-service';
import { IProductService } from '../../../../services/product/product-service';
import { EnergyLabelProductInfo } from '../../../shared';
import styles from './alternative-products-item-component.module.scss';
import { clickEvent } from '../../../../../../tagging/ensighten';
import { ProductDetailPage } from '../../../../../../generated/graphql';
import { getPrimaryImageUrl, IPDPMedia } from '../../../../models/pdp/pdp-media.model';

type AlternativeProductsItemProps = {
  labels?: ILabel[];
  mainProductStockCode: string;
  product: ProductDetailPage;
  incVat?: boolean;
  productService?: IProductService;
  basketService?: IBasketService;
};

export const AlternativeProductsItem: FunctionComponent<AlternativeProductsItemProps> = (props: AlternativeProductsItemProps) => {
  return (
    <div className={styles['alternative-product-container']}>
      <Link to={props.product.pdpUrl} className={styles['thumb-container']} onClick={ensightenClickEvent}>
        <img src={getPrimaryImageUrl(props.product.mediaArea as IPDPMedia)?.url} alt={props.product.titleArea?.title} />
      </Link>
      <div className={styles['product-details']}>
        <div className={styles['product-info-container']}>
          {/* Product Title */}
          <Link to={props.product.pdpUrl} className={styles['title']} onClick={ensightenClickEvent}>
            {props.product.titleArea?.title}
          </Link>
          {/* Brand */}
          <span>
            <span>{getLabel(props.labels, 'brand')}: </span>
            <a
              href={`/productlist/search?query=${props.product.titleArea?.brand.toLowerCase()}`}
              onClick={() => {
                props.basketService?.brandTrackerClickEvent('BrandSearchPDP', props.product.titleArea?.brand ?? '');
              }}>
              {props.product.titleArea?.brand}
            </a>
          </span>
          {/** Energy Label */}
          {props.product.energyArea?.energyLabel && (
            <EnergyLabelProductInfo
              labels={props.labels}
              energyArea={props.product.energyArea}
              stockCode={props.product.titleArea?.stockCode ?? ''}
              productService={props.productService}
            />
          )}
        </div>

        {/* Price */}
        <div className={styles['price-area']}>
          <span className={styles.price}>{props.product.priceArea?.price.priceAfter.displayValue}</span>
          <span className={styles.vat}>
            {props.product.priceArea?.container} {getLabel(props.labels, props.incVat ? 'inc_vat_brackets' : 'ex_vat_brackets')}
          </span>
        </div>
      </div>
    </div>
  );

  function ensightenClickEvent() {
    const eventData = {
      __Type: 'buttonTracker',
      __Info: 'Alternative product link',
      __Result: `${props.mainProductStockCode}, ${props.product.titleArea?.stockCode}`,
    };

    clickEvent(eventData);
  }
};
